module.exports = __webpack_public_path__ + "img/gengduo_active.70833747.png";